import update from 'immutability-helper'

export const ADD = 'sticky/add'
export const REMOVE = 'sticky/remove'
export const CLEAR = 'sticky/clear'
export const SHOW = 'sticky/show'
export const HIDE = 'sticky/hide'

export function add (props) {
  return { type: ADD, props }
}

export function remove (index) {
  return { type: REMOVE, index }
}

export function clear () {
  return { type: CLEAR }
}

export const actions = {
  add,
  remove,
  clear
}

const initialState = []

// Action Handlers
const ACTION_HANDLERS = {
  ADD: (state = initialState, action) => {
    return update(
      state,
      { $push: [action.props] }
    )
  },
  REMOVE: (state = initialState, action) => {
    return update(
      state,
      { $splice: [[action.index, 1]] }
    )
  },
  CLEAR: (state, action) => {
    return initialState
  }
}

export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/sticky.js